import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=78f0dade&scoped=true&"
import script from "./publish.vue?vue&type=script&lang=js&"
export * from "./publish.vue?vue&type=script&lang=js&"
import style0 from "./publish.vue?vue&type=style&index=0&id=78f0dade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0dade",
  null
  
)

export default component.exports